import React from 'react';
import Logo from './logo';

const Loader = React.forwardRef<HTMLDivElement>((_, ref) => (
  <div
    className="absolute top-0 bottom-0 left-0 right-0 z-20 flex items-center justify-center text-white bg-black"
    ref={ref}
  >
    <Logo className="animate-pulse" />
  </div>
));

export default Loader;
